<template>
    <footer class="footer">
        <div class="container">
            <div class="footer__wrapper">
                <div class="footer__tex">
                    <div class="footer__title">
                        {{ $t("message.technicalSupport") }}
                    </div>
                    <div class="footer__tex_text">
                        <p>{{ $t("message.technicalSupportText") }}</p>
                        <a href="mailto:info@tvcom.uz">info@tvcom.uz</a>
                    </div>
                    <div class="footer__tex_text">
                        <p>© 2025 ООО "TVPLUS".</p>
                    </div>
                </div>
                <nav class="footer__nav">
                    <Accordion>
                        <AccordionItem
                            v-for="item in navigation"
                            :key="item.name"
                        >
                            <template v-slot:accordion-trigger>
                                <p class="footer__title">{{ item.name }}</p>
                            </template>
                            <template v-slot:accordion-content>
                                <li
                                    v-for="link in item.list"
                                    class="footer__nav_item"
                                    :key="link.path"
                                >
                                    <a
                                        v-if="link?.target"
                                        class="footer__nav_link"
                                        :target="link.target"
                                        :href="link.path"
                                        >{{ link.name }}</a
                                    >
                                    <RouterLink
                                        v-else
                                        class="footer__nav_link"
                                        :to="link.path"
                                    >
                                        {{ link.name }}
                                    </RouterLink>
                                </li>
                            </template>
                        </AccordionItem>
                    </Accordion>
                </nav>
                <div class="footer__refs">
                    <div class="footer__refs__wrapper">
                        <div class="footer__refs__content">
                            <div class="footer__refs_socials">
                                <a
                                    :href="item.path"
                                    target="_blank"
                                    :aria-label="item.name"
                                    rel="noopener noreferrer"
                                    v-for="item in socials"
                                    :key="item.name"
                                    class="footer__refs_socials_link"
                                >
                                    <component :is="item.icon"></component>
                                </a>
                            </div>
                            <div class="footer__refs_downloads">
                                <ElLink
                                    href="https://apps.apple.com/app/tvcom-uz/id6479690034"
                                    tag="a"
                                    size="medium"
                                    :attrs="{
                                        target: '_blank',
                                        rel: 'noopener noreferrer',
                                        'aria-label': 'Appstore',
                                    }"
                                    type="grey"
                                >
                                    <template #icon-left>
                                        <appStore />
                                    </template>
                                    Appstore
                                </ElLink>
                                <ElLink
                                    :href="goToDownload()"
                                    tag="a"
                                    size="medium"
                                    :attrs="{
                                        target: '_blank',
                                        rel: 'noopener noreferrer',
                                        'aria-label': ' Google Play',
                                    }"
                                    type="grey"
                                >
                                    <template #icon-left>
                                        <playStore />
                                    </template>
                                    Google Play
                                </ElLink>
                                <ElLink
                                    href="https://appgallery.huawei.com/#/app/C109223373"
                                    tag="a"
                                    size="medium"
                                    :attrs="{
                                        target: '_blank',
                                        rel: 'noopener noreferrer',
                                        'aria-label': 'facebook',
                                    }"
                                    type="grey"
                                >
                                    <template #icon-left>
                                        <galareStore />
                                    </template>
                                    App Gallery
                                </ElLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { shallowRef, defineAsyncComponent } from "vue";
import Accordion from "../components/Footer/Accordion.vue";
import AccordionItem from "../components/Footer/Accordion-item.vue";
import { RouterLink } from "vue-router";
import fb from "../components/Footer/icons/fb.vue";
import inst from "../components/Footer/icons/inst.vue";
import ok from "../components/Footer/icons/ok.vue";
import tg from "../components/Footer/icons/tg.vue";
import vk from "../components/Footer/icons/vk.vue";
import you from "../components/Footer/icons/you.vue";
import galareStore from "../components/Footer/icons/galareStore.vue";
import appStore from "../components/Footer/icons/appStore.vue";
import playStore from "../components/Footer/icons/playStore.vue";
const ElLink = defineAsyncComponent(() => import("../components/ElLink"));

export default {
    components: {
        ElLink,
        Accordion,
        AccordionItem,
        galareStore,
        appStore,
        playStore,
    },
    data() {
        return {
            socials: [
                {
                    name: "Facebook",
                    path: "https://www.facebook.com/tvcom.uz/",
                    icon: shallowRef(fb),
                },
                {
                    name: "Instagram",
                    path: "https://www.instagram.com/tvcom.uz_official",
                    icon: shallowRef(inst),
                },
                // {
                //     name: "OK",
                //     path: "https://ok.ru/group/55898902429839",
                //     icon: shallowRef(ok),
                // },
                {
                    name: "Telegram",
                    path: "https://t.me/tvcom_uz",
                    icon: shallowRef(tg),
                },
                // {
                //     name: "VK",
                //     path: "https://vk.com/tvcom_official",
                //     icon: shallowRef(vk),
                // },
                {
                    name: "YouTube",
                    path: "ttps://www.youtube.com/@tvcom_uzb",
                    icon: shallowRef(you),
                },
            ],
        };
    },
    computed: {
        navigation() {
            return [
                {
                    name: this.$t("message.navigation"),
                    list: [
                        {
                            name: this.$t("message.mainPage1"),
                            path: "/",
                        },
                        {
                            name: this.$t("message.tv"),
                            path: `${
                                this.$i18n.locale === "ru" ? "" : "/uz"
                            }/tv`,
                        },
                        {
                            name: this.$t("message.movies"),
                            path: "/movies",
                        },
                        {
                            name: this.$t("message.serials"),
                            path: "/serials",
                        },
                        {
                            name: this.$t("message.kids"),
                            path: "/kids",
                        },
                        {
                            name: this.$t("message.uzbList"),
                            path: "/uzb",
                        },
                        {
                            name: this.$t("message.myMovies"),
                            path: "/my/favourites",
                        },
                    ],
                },
                {
                    name: this.$t("message.help"),
                    list: [
                        {
                            name: this.$t("message.payWays"),
                            path: "/pay",
                        },
                        {
                            name: this.$t("message.tariffs"),
                            path: "/cabinet",
                        },
                        {
                            name: this.$t("message.questionanswer"),
                            path: "/answers",
                        },
                        {
                            name: "Android / Android TV",
                            path: "/android",
                        },
                        {
                            name: "LG Smart TV",
                            path: "/Lg",
                        },
                        {
                            name: "Samsung Smart TV",
                            path: "/Samsung",
                        },
                    ],
                },
                {
                    name: this.$t("message.aboutus"),
                    list: [
                        {
                            name: this.$t("message.news"),
                            path: `${
                                this.$i18n.locale === "ru" ? "" : "/uz"
                            }/news`,
                        },
                        {
                            name: this.$t("message.aboutCompany"),
                            path: "/about",
                        },
                        {
                            name: this.$t("message.workin"),
                            path: "/job",
                        },
                        {
                            name: this.$t("message.privacyPolicy"),
                            path: "/policy",
                        },
                        {
                            name: this.$t("message.useAgreement"),
                            path: "http://tvcom.uz/documents/oferta.pdf",
                            target: "_blank",
                        },
                    ],
                },
            ];
        },
    },
    methods: {
        goToDownload() {
            function getCookie(name) {
                const cookies = document.cookie.split("; ");
                for (let cookie of cookies) {
                    const [key, value] = cookie.split("=");
                    if (key === name) {
                        return decodeURIComponent(value);
                    }
                }
                return null;
            }

            let utm_source = getCookie("utm_source");
            let utm_medium = getCookie("utm_medium");
            let utm_campaign = getCookie("utm_campaign");
            return `https://play.google.com/store/apps/details?id=uz.comnet.tvcomstb&referrer=${encodeURIComponent(
                `utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`
            )}`;
        },
    },
};
</script>

<style lang="scss">
.footer {
    padding: 40px 40px 90px 40px;
    @media (max-width: 1024px) {
        display: none;
    }
    &__wrapper {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 30px;
    }
    &__title {
        color: #fff;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 110%; /* 19.8px */
        letter-spacing: 0.18px;
        margin-bottom: 50px;
    }
    &__tex {
        min-width: 227px;
        flex: 1;
        &_title {
            max-width: 250px;
        }
        &_text {
            display: flex;
            flex-direction: column;
            gap: 12px;
            max-width: 250px;
            margin-bottom: 30px;
            p {
                color: rgba(255, 255, 255, 0.45);
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 110%; /* 15.4px */
                letter-spacing: 0.14px;
            }
            a {
                color: rgba(255, 255, 255, 0.45);
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 110%; /* 15.4px */
                letter-spacing: 0.14px;
                transition: 0.3s ease;
                &:hover {
                    color: #fff;
                }
            }
        }
    }
    &__nav {
        flex: 2;
        display: flex;
        @media (max-width: 1199.98px) {
            flex: 3;
        }
        .accordion {
            display: flex;
            width: 100%;
            justify-content: space-around;
            gap: 30px;
            &__content {
                list-style: none;
                display: flex;
                flex-direction: column;
                gap: 12px;
                // max-height: 0;
                // opacity: 0;
                // &_active {
                //     transition: 0.3s ease;
                //     opacity: 1;
                //     max-height: 100%;
                // }
            }
        }
        &_link {
            color: rgba(255, 255, 255, 0.45);
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 110%; /* 15.4px */
            letter-spacing: 0.14px;
            transition: 0.3s ease;
            &:hover {
                color: #fff;
            }
        }
    }
    &__refs {
        flex: 1;
        &__wrapper {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 55px;
            height: 100%;
        }
        &__content {
            justify-content: space-between;
            display: flex;
            gap: 30px;
            flex-wrap: wrap;
            @media (max-width: 1199.98px) {
                justify-content: flex-end;
            }
        }
        &__info {
            display: flex;
            justify-content: flex-end;
            p {
                color: rgba(255, 255, 255, 0.45);
                text-align: right;
                font-size: 8px;
                font-style: normal;
                font-weight: 400;
                line-height: 120%; /* 9.6px */
                max-width: 350px;
            }
        }
        &_socials {
            display: flex;
            column-gap: 24px;
            flex-wrap: wrap;
            width: 88px;
            flex-shrink: 0;
            &_link {
                width: 32px;
                height: 32px;
                flex-shrink: 0;
                color: #747373;
                transition: 0.3s ease;
                &:hover {
                    color: #fff;
                }
                svg {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        &_downloads {
            display: flex;
            flex-direction: column;
            gap: 10px;
            .el-button {
                &.is-medium {
                    --padding-x: 20px;
                    --svg--size: 16px;
                    font-weight: 400;
                    font-size: 14px;
                    --height: 36px;
                    --border-radius: 36px;
                }
                &__text {
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>
